export interface Emitter {
  subscribe: (listener: () => void) => () => void;
  notify: () => void;
}

export function createEmitter(): Emitter {
  const listeners = new Set<() => void>();
  return {
    subscribe(listener) {
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
      };
    },
    notify() {
      listeners.forEach((listener) => listener());
    },
  };
}
